<button
	(click)="openFrillFeedback()"
	[disabled]="(giftLoading$ | async) || (giftError$ | async)"
	[matBadge]="giftBadgeCount$ | async"
	[matBadgeHidden]="!(giftBadgeCount$ | async)"
	class="mat-icon-button-flex"
	mat-icon-button
	matBadgeColor="warn"
	matBadgeOverlap
>
	@if (!(giftLoading$ | async)) {<mat-icon svgIcon="gift"></mat-icon>} @else {
	<mat-progress-spinner
		[diameter]="18"
		[strokeWidth]="2"
		mode="indeterminate"
	></mat-progress-spinner>
	}
</button>
